import React, { useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { MainLayout } from "../components";
import { APICredentialsPage, GettingStartedPage, HelpPage, LinkInfra } from "../pages";
import { WebhooksRoutes } from "../routes";

export default function DeveloperModule() {
  return (
    <MainLayout>
      <Routes path="">
        <Route path="help" element={<HelpPage />} />
        <Route path="getting-started" element={<GettingStartedPage />} />
        <Route path="webhooks/*" element={<WebhooksRoutes />} />
        <Route path="api-credentials" element={<APICredentialsPage />} title="Credentials Page" />
        <Route path="*" element={<Navigate to="getting-started/" />} />
      </Routes>
    </MainLayout>
  );
}
